import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';
import './Error.css';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const Error = () => {


  return (
    <>
      <div className="home-container">
        <Navbar />

        <div className='error-hero'>
            <div className='cloud-container'>
                <DotLottieReact
                src="/assets/face-in-clouds.json"
                loop
                autoplay
                className='face-clouds'
                />
                <img src='/assets/404.svg' alt='face-cloud' />
            </div>
            <div className='home-link-container'>
                <p>Something went wrong!</p>
                <Link to='/' className='home-link'>
                  <p className='home-link-btn'>Home</p>
                </Link>
            </div>
        </div>

        <Footer/>
      </div>
    </>
  );
};

export default Error;